import * as React from 'react';
type Props = {
  className?: string;
};
export function Vegetarian2({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-vegetarian2"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84268 3.00199C10.708 2.95403 12.4734 3.77486 14.0987 5.43305H19.7494V7.26451H14.2643C13.6339 7.95002 11.7005 9.79545 9.01836 9.94776C8.89967 9.95446 8.78097 9.95804 8.66271 9.95804C6.74387 9.95804 4.88888 9.07137 3.14402 7.31951C2.81107 6.98505 2.78365 6.43821 3.08146 6.06932C3.17958 5.94815 5.51964 3.09633 8.84268 3.00199ZM5.03671 6.62198C6.3068 7.68616 7.6073 8.1856 8.90867 8.11987C10.5248 8.03307 11.8358 7.08359 12.5505 6.43591V6.41814C11.3779 5.33362 10.1545 4.80801 8.90181 4.83255C7.21994 4.87592 5.80331 5.91953 5.03671 6.62198ZM3.76886 11.4358H19.6157L19.6569 12.3064C19.6689 12.4602 19.674 12.5411 19.674 12.623C19.674 15.6371 17.5555 18.2609 14.3323 19.3286V21H8.212V19.3277C4.9918 18.2591 2.875 15.6353 2.875 12.623C2.875 12.5425 2.88057 12.4629 2.887 12.3837L2.92428 11.5087L3.76886 11.4358ZM12.5772 17.913L13.2482 17.744C15.7412 17.1144 17.5521 15.325 17.8692 13.2673H4.69357C5.03208 15.359 6.83051 17.1189 9.29654 17.744L9.96715 17.9139V19.1685H12.5772V17.913Z"
        fill="currentColor"
      />
    </svg>
  );
}
